export const TEXTS = {
  SAVED_PREFIX: 'Saved ',
  YOU_PAY: 'You Pay',
  ONLY_LEFT_PREFIX: 'Only ',
  ONLY_LEFT_SUFFIX: ' left',
  PRICE_DROPPED_PREFIX: 'Price dropped by ',
  PRICE_DROPPED_AMOUNT_PREFIX: 'by ',
  DEFAULT_SALE_TAG: 'Pink friday sale',
  DEFAULT_LUXE_TAG: 'LUXE',
  DEFAULT_URGENCY_TAG: 'Selling fast',
  OOS_UNAVAILABLE_TEXT: 'Product no longer available',
  OOS_SECTION_TITLE: 'Out of stock Items',
  OOS_REMOVE_ALL: 'Remove all',
};

const TAG_IMAGE_BASE =
  'https://images-static.nykaa.com/fashion-images/pub/media/fashion-images/cartuxrevamptags';

/** Cart UX revamp tag assets (CDN). */
export const TAG_IMAGES = {
  luxe: `${TAG_IMAGE_BASE}/luxetag.png`,
  freeGift: `${TAG_IMAGE_BASE}/freegift.png`,
  nexpress: `${TAG_IMAGE_BASE}/nexpress.png`,
  peopleBrowsing: `${TAG_IMAGE_BASE}/peoplebrowsing.png`,
  pinkFridaySale: `https://images-static.nykaa.com/fashion-images/pub/media/fashion-images/pinkfridaysale.png`,
  priceDrop: `${TAG_IMAGE_BASE}/pricedropped.png`,
  sale: `https://images-static.nykaa.com/fashion-images/pub/media/fashion-images/sale-v1.svg`,
  sellingFast: `${TAG_IMAGE_BASE}/sellingfast.png`,
  sellingFastColored: `${TAG_IMAGE_BASE}/sellingfastcolored.png`,
} as const;

export const TAG_ALT = {
  luxe: 'Luxe',
  freeGift: 'Free gift',
  nexpress: 'Nykaa Express',
  peopleBrowsing: 'People browsing',
  pinkFridaySale: 'Pink Friday sale',
  priceDrop: 'Price dropped',
  sale: 'Sale',
  sellingFast: 'Selling fast',
} as const;

export const CART_ITEM_TAG_TYPE = {
  ON_SALE: 'ON_SALE',
  PRICE_DROP: 'PRICE_DROP',
  SELLING_FAST: 'SELLING_FAST',
  THIRTY_DAY_BEST_PRICE: 'THIRTY_DAY_BEST_PRICE',
  TRENDING_NOW: 'TRENDING_NOW',
  TOP_RATED: 'TOP_RATED',
  LUXE: 'LUXE',
} as const;

export const TAG_TEXT_CONFIG = {
  freeGift: {
    backgroundColor: '#EDFFF7',
    textColor: '#047E66',
  },
  priceDrop: {
    backgroundColor: '#EDFFF7',
    textColor: '#047E66',
  },
  sale: {
    backgroundColor: '#FBEDFF',
    textColor: '#6E3A83',
    textGradient:
      'linear-gradient(0deg, #6E3A83, #6E3A83), linear-gradient(90deg, #FF2EB6 0%, #B824E0 100%)',
  },
  pinkFridaySale: {
    backgroundColor: '#FBEDFF',
    textColor: '#6E3A83',
    textGradient:
      'linear-gradient(0deg, #6E3A83, #6E3A83), linear-gradient(90deg, #FF2EB6 0%, #B824E0 100%)',
  },
  sellingFast: {
    backgroundColor: '#F4F2F1',
    textColor: '#776C67',
  },
  sellingFastColored: {
    backgroundColor: '#FFF1D9',
    textColor: '#C2861E',
  },
  peopleBrowsing: {
    backgroundColor: '#FFF1D9',
    textColor: '#C2861E',
  },
  luxe: {
    backgroundColor: '#081125',
    textColor: '#FFFFFF',
  },
} as const;
